export default {
  PUSH_TEST_TEMPLATE: 'PUSH_TEST_TEMPLATE',
  SET_TEST_TEMPLATES: 'SET_TEST_TEMPLATES',
  UPDATE_TEST_TEMPLATE: 'UPDATE_TEST_TEMPLATE',
  DELETE_TEST_TEMPLATE: 'DELETE_TEST_TEMPLATE',
  SET_TEST_TEMPLATE_REPORTS: 'SET_TEST_TEMPLATE_REPORTS',
};
